import styled from 'styled-components';

export const MainWrapper = styled.div`
  & > div:first-child {
    margin-bottom: 16px;
  }

  & > div:nth-child(5) {
    margin-top: 16px;
  }
`;

export const InfoElement = styled.div`
  display: flex;
  margin: 16px 0;
  & > div:first-child {
    margin-right: 8px;
  }
`;

export const InfoBlock = styled.div`
  margin-right: 48px;
`;

export const InfoWrapper = styled.div`
  display: flex;
`;
